<template>
    <div>
      <div class="section-header">
        <div class="title">
          Info
        </div>
        <div class="divider"></div>
      </div>
      <div style="margin-right: 16px; margin-left: 16px;">
        <div class="flex">
          <span class="mgra sub-header">ID</span>
          <span>{{ audit.id }}</span>
        </div>
        <div class="flex">
          <span class="mgra sub-header">Date</span>
          <span>{{ audit.created_at }}</span>
        </div>
        <div class="flex">
          <span class="mgra sub-header">Action</span>
          <span>{{ audit.event }}</span>
        </div>
        <div class="flex">
          <span class="mgra sub-header">Class</span>
          <span>{{ audit.auditable_type }}</span>
        </div>
        <div class="flex">
          <span class="mgra sub-header">URL</span>
          <span>{{ audit.url }}</span>
        </div>
      </div>
      <div class="section-header">
        <div class="title">
          User
        </div>
        <div class="divider"></div>
      </div>
      <div style="margin-right: 16px; margin-left: 16px;">
        <div class="flex">
          <span class="mgra sub-header">User ID</span>
          <span>{{ audit.user_id }}</span>
        </div>
        <div class="flex">
          <span class="mgra sub-header">Username</span>
          <span>{{ audit.username }}</span>
        </div>
        <div class="flex">
          <span class="mgra sub-header">IP</span>
          <span>{{ audit.ip_address }}</span>
        </div>
        <div class="flex">
          <span class="mgra sub-header">Agent</span>
          <span>{{ audit.user_agent }}</span>
        </div>
      </div>
      <div class="section-header">
        <div class="title">
          Data
        </div>
        <div class="divider"></div>
      </div>
      <div style="margin-right: 16px; margin-left: 16px;">
        <div class="flex">
          <span class="mgra sub-header">Old</span>
          <span>{{ audit.old_values }}</span>
        </div>
        <div class="flex">
          <span class="mgra sub-header">New</span>
          <span>{{ audit.new_values }}</span>
        </div>
      </div>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
    components: {},
    props: ['audit'],
    data() {
        return {};
    },
    computed: {
        ...mapFields([
            'user'
        ])

    }
}
</script>
